import { defineNuxtRouteMiddleware, navigateTo } from '#imports';
import { SEO_REDIRECTION_CODE } from '~~/constants/seo';

export default defineNuxtRouteMiddleware((to) => {

  const forcedLowercasePath = to.path.toLowerCase();

  if (forcedLowercasePath === to.path) {

    return;

  }

  return navigateTo(
    {
      path: forcedLowercasePath,
      query: to.query,
      hash: to.hash,
    },
    {
      replace: true,
      redirectCode: SEO_REDIRECTION_CODE,
    },
  );

});
